import { render, staticRenderFns } from "./to.vue?vue&type=template&id=579b80c2&scoped=true"
import script from "./to.vue?vue&type=script&lang=js"
export * from "./to.vue?vue&type=script&lang=js"
import style0 from "./to.vue?vue&type=style&index=0&id=579b80c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b80c2",
  null
  
)

export default component.exports